import '../component/Sidebar/Sidebar.css'
import {AdminRoles} from "../context/reducer";

export const RouteHelper = {
    Root: {
        key: "ROOT",
        url: "/",
        globalUrl: "/panel/",
        name: "داشبورد",
        icon: 'ic-game-play',
        accessRole: []
    },
    Dashboard: {
        key: "DASHBOARD",
        url: "dashboard",
        globalUrl: "/panel/dashboard",
        name: "داشبورد",
        icon: 'ic-dashboard',
        accessRole: []
    },
    Union: {
        key: "UNION",
        url: "union",
        globalUrl: "/panel/union",
        name: "اتحادیه",
        icon: 'ic-union',
        accessRole: []
    },
    Groups: {
        key: "GROUPS",
        name: "گروه ها",
        icon: 'ic-group',
        accessRole: []
    },
    GroupsList: {
        key: "GROUPS_LIST",
        name: "گروه ها",
        url: "groups",
        globalUrl: "/panel/groups",
        icon: 'ic-group',
        accessRole: []
    },
    GroupsReport: {
        key: "GROUPS_REPORT",
        name: "گزارش گیری",
        url: "groups-report",
        globalUrl: "/panel/groups-report",
        icon: 'ic-dashboard',
        accessRole: []
    },

    Accounts: {
        key: "ACCOUNTS",
        name: "حساب ها",
        icon: 'ic-cash',
        accessRole: []
    },

    Loans: {
        key: "LOANS",
        name: "وام ها",
        icon: 'ic-loans',
        accessRole: []
    },

    AccountsList: {
        key: "ACCOUNT_LIST",
        name: "حساب ها",
        url: "accounts",
        globalUrl: "/panel/accounts",
        icon: 'ic-dashboard',
        accessRole: []
    },

    AccountsTransactionsList: {
        key: "ACCOUNT_TRANSACTION",
        name: "تراکنشات حساب",
        url: "account-transactions",
        globalUrl: "/panel/account-transactions",
        icon: 'ic-dashboard',
        accessRole: []
    },

    AccountsNewTransaction: {
        key: "ACCOUNT_NEW_TRANSACTION",
        name: "تراکنشات گروهی حساب",
        url: "account-new-transactions",
        globalUrl: "/panel/account-new-transactions",
        icon: 'ic-dashboard',
        accessRole: []
    },

    AccountsUpdateTransaction: {
        key: "ACCOUNT_UPDATE_TRANSACTION",
        name: "ویرایش تراکنشات گروهی حساب",
        url: "account-update-transactions",
        globalUrl: "/panel/account-update-transactions",
        icon: 'ic-dashboard',
        accessRole: []
    },

    AccountsCheckout: {
        key: "ACCOUNT_CHECKOUT",
        name: "تسویه حساب",
        url: "account-checkout",
        globalUrl: "/panel/account-checkout",
        icon: 'ic-dashboard',
        accessRole: []
    },

    AccountsDetail: {
        key: "ACCOUNT_DETAIL",
        name: "جزئیات حساب",
        url: "accounts/:id",
        globalUrl: "/panel/accounts/:id",
        icon: 'ic-dashboard',
        accessRole: []
    },

    LoansList: {
        key: "LOANS_LIST",
        name: "وام ها",
        url: "loans",
        globalUrl: "/panel/loans",
        icon: 'ic-dashboard',
        accessRole: []
    },

    LoansCreateNewItem: {
        key: "LOANS_LIST",
        name: "وام ها",
        url: "create-loan",
        globalUrl: "/panel/create-loan",
        icon: 'ic-dashboard',
        accessRole: []
    },


    LoanDetail: {
        key: "LOAN_DETAIL",
        name: "جزئیات وام",
        url: "loans/:id",
        globalUrl: "/panel/loans/:id",
        icon: 'ic-dashboard',
        accessRole: []
    },


    InstallmentsList: {
        key: "INSTALLMENTS",
        name: "اقساط",
        url: "installments",
        globalUrl: "/panel/installments",
        icon: 'ic-dashboard',
        accessRole: []
    },

    PayInstallments: {
        key: "INSTALLMENTS",
        name: "پرداخت اقساط",
        url: "pay-installments",
        globalUrl: "/panel/pay-installments",
        icon: 'ic-dashboard',
        accessRole: []
    },

    LoansRequests: {
        key: "LOAN_REQUESTS",
        name: "درخواست وام",
        url: "loan-requests",
        globalUrl: "/panel/loan-requests",
        icon: 'ic-dashboard',
        accessRole: []
    },
    LogsList: {
        key: "LOG_LIST",
        name: "لاگ ها",
        url: "logs",
        globalUrl: "/panel/logs",
        icon: 'ic-radar',
        accessRole: []
    },

    LogsDetail: {
        key: "LOGS_DETAIL",
        name: "جزئیات لاگ",
        url: "logs/:id",
        globalUrl: "/panel/logs/:id",
        icon: 'ic-dashboard',
        accessRole: []
    },

    LoansRequestsDetail: {
        key: "LOAN_REQUEST_DETAIL",
        name: "جزئیات درخواست وام",
        url: "loan-request_detail/:id",
        globalUrl: "/panel/loan-request_detail/:id",
        icon: 'ic-dashboard',
        accessRole: []
    },


    GroupsDetail: {
        key: "GROUPS_DETAIL",
        name: "جزئیات گروه",
        url: "groups/:id",
        globalUrl: "/panel/groups/:id",
        icon: 'ic-dashboard',
        accessRole: []
    },
    CashInfo: {
        key: "CASH_INFO",
        url: "cash-info",
        globalUrl: "/panel/cash-info",
        name: "صندوق",
        icon: 'ic-safe-box',
        accessRole: []
    },
    Magazine: {
        key: "MAGAZINE",
        name: "مجله",
        icon: 'ic-magazine',
        accessRole: [
            AdminRoles.READ_POSTS_LIST.role,
            AdminRoles.READ_POST_CATEGORY_TREE.role,
            AdminRoles.READ_POST_TAGS_LIST.role,
            AdminRoles.READ_FILES_LIST.role,
            AdminRoles.READ_POST_WRITERS_LIST.role,
        ]
    },
    MagazineList: {
        key: "MAGAZINE_LIST",
        url: "magazine",
        globalUrl: "/panel/magazine",
        name: "آخرین مطالب",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.READ_POSTS_LIST.role]
    },
    MagazineCategory: {
        key: "MAGAZINE_CATEGORY",
        url: "magazine-category",
        globalUrl: "/panel/magazine-category",
        name: "دسته بندی",
        icon: "ic-menu",
        accessRole: [AdminRoles.READ_POST_CATEGORY_TREE.role]
    },

    FileManager: {
        key: "FILE_MANAGER",
        url: "file-manager",
        globalUrl: "/panel/file-manager",
        name: "فایل ها",
        icon: "ic-game-play",
        accessRole: [AdminRoles.READ_FILES_LIST.role]
    },
    MagazineWriters: {
        key: "MAGAZINE_WRITERS",
        url: "magazine-writers",
        globalUrl: "/panel/magazine-writers",
        name: "نویسنده ها",
        icon: "ic-menu",
        accessRole: [AdminRoles.READ_POST_WRITERS_LIST.role]
    },
    MagazineWriterDetail: {
        key: "MAGAZINE_WRITERS",
        url: "magazine-writers/:id",
        globalUrl: "/panel/magazine-writers/:id",
        name: "جزئیات نویسنده",
        icon: "ic-menu",
        accessRole: [AdminRoles.READ_POST_WRITER_INFORMATION.role]
    },
    Managers: {
        id: "Managers",
        name: "مدیران",
        icon: "ic-managers",
        accessRole: [AdminRoles.READ_ADMINS_LIST.role, AdminRoles.READ_ADMIN_PERMISSIONS_LIST.role]
    },
    ManagersList: {
        key: "MANAGER_LIST",
        url: "managers",
        globalUrl: "/panel/managers",
        name: "لیست مدیران",
        icon: "ic-residence",
        accessRole: [AdminRoles.READ_ADMINS_LIST.role]
    },
    MagazineDetail: {
        key: "MANAGER_DETAIL",
        url: "magazine/:id",
        globalUrl: "/panel/magazine/:id",
        name: "جزئیات",
        icon: "ic-game-play",
        accessRole: [AdminRoles.READ_ADMIN_INFORMATION.role]
    },
    ManagersAccess: {
        key: "MANAGER_ACCESS",
        url: "managers/managers-access",
        globalUrl: "/panel/managers/managers-access",
        name: "سطح دسترسی",
        icon: "ic-access-level",
        accessRole: [AdminRoles.READ_ADMIN_PERMISSIONS_LIST.role]
    },
    Tour: {
        key: "TOUR",
        name: "تور",
        icon: "ic-tour",
        accessRole: [AdminRoles.READ_TOUR_LEADERS_LIST.role,]
    },
    FAQ: {
        key: "FAQ",
        name: "سوالات متداول",
        icon: 'ic-question',
        accessRole: []
    },
    FaqList: {
        key: "FAQ_LIST",
        name: "سوالات متداول",
        url: "faq_list",
        globalUrl: "/panel/faq_list",
        icon: "ic-question",
        accessRole: []
    },
    RulesList: {
        key: "RULES_LIST",
        name: "قوانین",
        url: "rules_list",
        globalUrl: "/panel/rules_list",
        icon: "",
        accessRole: []
    },
    RuleDetails: {
        key: "RULE_DETAILS",
        name: "جزئیات قانون",
        url: "rule-details/:id",
        globalUrl: "/panel/rule-details/:id",
        icon: "",
        accessRole: []
    },
    FaqDetail: {
        key: "FAQ_Detail",
        name: "جزئیات پرسش",
        url: "faq_info/:id",
        globalUrl: "/panel/faq_info/:id",
        icon: "ic-question",
        accessRole: []
    },
    TourFileManager: {
        key: "TOUR_FILE_MANAGER",
        url: "tour-file-manager",
        globalUrl: "/panel/tour-file-manager",
        name: "فایل ها",
        icon: "ic-game-play",
        accessRole: [AdminRoles.READ_FILES_LIST.role]
    },
    // PaymentGateway: {
    //     key: "PAYMENT_GATEWAY",
    //     name: "امور مالی",
    //     icon: 'ic-transactions',
    //     accessRole: []
    // },
    PaymentGatewaysList: {
        key: "PAYMENT_GATEWAYS_LIST",
        name: "درگاه های پرداخت",
        url: "payment-gateways",
        globalUrl: "/panel/payment_gateways",
        icon: "ic-question",
        accessRole: []
    },
    PaymentGatewaysInformation: {
        key: "PAYMENT_GATEWAYS_LIST",
        name: "اطلاعات درگاه پرداخت",
        url: "payment-gateways/:id",
        globalUrl: "/panel/payment-gateways/:id",
        icon: "ic-question",
        accessRole: []
    },
    TransactionsList: {
        key: "TRANSACTIONS_LIST",
        name: "تراکنشات بانکی",
        url: "transactions",
        globalUrl: "/panel/transactions",
        icon: "ic-transactions-list",
        accessRole: []
    },
    TransactionDetail: {
        key: "TRANSACTION_DETAIL",
        name: "جزئیات تراکنش",
        url: "transactions/:id",
        globalUrl: "/panel/transactions/:id",
        icon: "",
        accessRole: []
    },
    CostAndRevenue: {
        key: "COST_AND_REVENUE",
        name: "درآمد و هزینه",
        icon: 'ic-transactions',
        accessRole: []
    },
    CashTransactions: {
        key: "CASH_TRANSACTION",
        name: "تراکنشات",
        url: "cash-transaction",
        globalUrl: "/panel/cash-transaction",
        icon: 'ic-transactions',
        accessRole: []
    },
    CashTransactionsDetails: {
        key: "CASH_TRANSACTION_DETAILS",
        name: "جزئیات تراکنش",
        url: "cash-transaction-details/:id",
        globalUrl: "/panel/cash-transaction-details/:id",
        icon: 'ic-transactions',
        accessRole: []
    },
    CostAndRevenueCategory: {
        key: "COST_AND_REVENUE_CATEGORY",
        name: "دسته بندی",
        url: "cost-and-revenue-category",
        globalUrl: "/panel/cost-and-revenue-category",
        icon: 'ic-transactions',
        accessRole: []
    },
    TagList: {
        key: "MAGAZINE_TAGS",
        url: "magazine-tags",
        globalUrl: "/panel/magazine-tags",
        name: "تگ ها",
        icon: "ic-game-play",
        accessRole: []
    },
    FeedBack: {
        key: "FEEDBACK",
        url: "feedback",
        globalUrl: "/panel/feedback",
        name: "بازخورد",
        icon: "ic-feedback",
        accessRole: []
    },
    FeetBackInfo: {
        key: "FEEDBACK_INFO",
        url: "feedback-info/:id",
        globalUrl: "/panel/feedback-info/:id",
        name: "اطلاعات بازخورد",
        icon: "ic-game-play",
        accessRole: []
    },
    Election: {
        key: "ELECTION",
        url: "election",
        globalUrl: "/panel/election",
        name: "انتخابات",
        icon: "ic-election",
        accessRole: []
    },
    ElectionDetails: {
        key: "ELECTION-DETAILS",
        url: "election-details/:id",
        globalUrl: "/panel/election-details/:id",
        name: "جزئیات انتخابات",
        icon: "ic-election",
        accessRole: []
    },
    OtherPayments: {
        key: "OTHER_PAYMENTS",
        url: "other-payments",
        globalUrl: "/panel/other-payments",
        name: "سایر پرداخت ها",
        icon: "ic-wallet",
        accessRole: []
    },
    OtherPaymentsDetails: {
        key: "OTHER_PAYMENTS_DETAILS",
        url: "other-payments-details/:id",
        globalUrl: "/panel/other-payments-details/:id",
        name: "جزئیات سایر پرداخت",
        icon: "",
        accessRole: []
    },
    Users: {
        key: "USERS",
        url: "users",
        globalUrl: "/panel/users",
        name: "اعضا صندوق",
        icon: 'ic-users',
        accessRole: []
    },
    UserInformation: {
        key: "USERS_INFORMATION",
        url: "user-information/:id",
        globalUrl: "/panel/user-information/:id",
        name: "اطلاعات کاربر",
        icon: '',
        accessRole: []
    },
}

export const RouteInfo = {
    Root: {
        url: "/panel",
        globalUrl: "/panel/",
        name: "داشبورد",
        icon: 'ic-game-play',
        accessRole: []
    },
    Dashboard: {
        url: "dashboard",
        globalUrl: "/panel/dashboard",
        name: "داشبورد",
        icon: 'ic-dashboard',
        accessRole: []
    },
    MagazineList: {
        url: "magazine",
        globalUrl: "/panel/magazine",
        name: "مجله",
        icon: 'ic-game-play',
        accessRole: []
    },
    TourLeadersList: {
        url: "tour-leader-list",
        globalUrl: "/panel/tour-leader-list",
        name: "تور لیدر ها",
        icon: 'ic-game-play',
        accessRole: []
    },
    Managers: {
        id: "Managers",
        url: "managers",
        globalUrl: "/panel/managers",
        name: "مدیران",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    ManagersList: {
        url: "managers/managers-list",
        globalUrl: "/panel/managers/managers-list",
        name: "مدیران",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },

    MagazineDetail: {
        url: "magazine/:id",
        globalUrl: "/panel/magazine/:id",
        name: "جزئیات",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    MagazineCategory: {
        url: "magazine-category",
        globalUrl: "/panel/magazine-category",
        name: "دسته بندی",
        icon: "ic-menu",
        accessRole: []
    },
    ManagersAccess: {
        url: "managers/managers-access",
        globalUrl: "/panel/managers/managers-access",
        name: "سطح دسترسی",
        icon: "ic-access-level",
        accessRole: []
    },
    ManagersAccessDetail: {
        url: "managers-access/:id",
        globalUrl: "/panel/managers-access/:id",
        name: "سطح دسترسی",
        icon: "ic-access-level",
        accessRole: []
    },
    QUESTIONS: {
        url: "questions",
        globalUrl: "/panel/questions",
        name: "سوالات",
        icon: 'ic-question',
        accessRole: []
    },
    FILE_MANAGER: {
        url: "file-manager",
        globalUrl: "/panel/file-manager",
        name: "فایل ها",
        icon: 'ic-file',
        accessRole: []
    },
    REPORTS: {
        url: "reports",
        globalUrl: "/panel/reports",
        name: "گزارشات",
        icon: 'ic-report',
        accessRole: []
    },
    LEARNS: {
        url: "learns",
        globalUrl: "/panel/learns",
        name: "آموزش ها",
        icon: 'ic-learn',
        accessRole: []
    },
    INFO: {
        url: "info",
        globalUrl: "/panel/info",
        name: "پشتیبانی",
        icon: 'ic-info',
        accessRole: []
    },
    BOX: {
        url: "reports",
        globalUrl: "/panel/reports",
        name: "پیام ها",
        icon: 'ic-box',
        accessRole: []
    },


    Profile: {
        url: "profile",
        globalUrl: "/panel/profile",
        name: "حساب کاربری",
        icon: 'magazine-icon',
        accessRole: []
    },
    SecondItem: {
        url: "second-item",
        globalUrl: "/panel/second-item",
        name: "نمونه جدول",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    DefaultListPage: {
        url: "default-list",
        globalUrl: "/panel/default-list",
        name: "لیست پیشفرض",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    DefaultInputsPage: {
        url: "default-inputs",
        globalUrl: "/panel/default-inputs",
        name: "اینپوت پیشفرض",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    Category: {
        url: "category",
        globalUrl: "/panel/category",
        name: "دسته بندی",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    ReleaseDocuments: {
        url: "release-documents",
        globalUrl: "/panel/release-documents",
        name: "اسناد انتشار",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    Files: {
        url: "file-manager",
        globalUrl: "/panel/file-manager",
        name: "فایل ها",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    Login: {
        url: "panel/login",
        globalUrl: "/panel/login",
        name: "ورود",
        icon: '',
        accessRole: []
    },
    SignInForgetPassword: {
        url: "forget-password",
        globalUrl: "/panel/signIn/forget-password",
        name: "فراموشی رمز عبور",
        icon: '',
        accessRole: []
    },
    ConfirmPhoneNumber: {
        url: "panel/confirm-phone-number",
        globalUrl: "/panel/confirm-phone-number",
        name: "تایید شماره تماس",
        icon: '',
        accessRole: []
    },
    PasswordRecovery: {
        url: "panel/password-recovery",
        globalUrl: "/panel/password-recovery",
        name: "بازیابی رمز عبور",
        icon: '',
        accessRole: []
    },

    ManagersDetail: {
        url: "managers-detail/:id",
        globalUrl: "/panel/managers-detail/:id",
        name: "جزئيات مدیر",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },

    AppVersionList: {
        url: "app-version-list",
        globalUrl: "/panel/app-version-list",
        name: "نسخه ها",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    SimpleBarChart: {
        url: "simple-bar-chart",
        globalUrl: "/panel/SimpleBarChart",
        name: "نمودار میله ای ساده",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    PieChartWithPaddingAngle: {
        url: "Pie-chart-with-padding-angle",
        globalUrl: "/panel/Pie-chart-with-padding-angle",
        name: "نمودار دایره ای با فاصله",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    VerticalBarChart: {
        url: "vertical-bar-chart",
        globalUrl: "/panel/vertical-bar-chart",
        name: "نمودار میله ای عمودی",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    SimplePieChart: {
        url: "simple-pie-chart",
        globalUrl: "/panel/simple-pie-chart",
        name: "نمودار دایره ای ساده",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    DoughnutChart: {
        url: "doughnut-chart",
        globalUrl: "/panel/doughnut-chart",
        name: "نمودار دونات",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    PieChart: {
        url: "pie-chart",
        globalUrl: "/panel/pie-chart",
        name: "نمودار دایره ای",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    Charts: {
        url: "chart-sample",
        globalUrl: "/panel/chart-sample",
        name: "نمودارها",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    Exam: {
        url: "Exam",
        globalUrl: "/panel/Exam",
        name: "امتحان",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    SignIn: {
        url: "panel/signIn/*",
        globalUrl: "/panel/signIn",
        name: "ورود",
        icon: '',
        accessRole: []
    },
    SignInEnterSubmitCode: {
        url: "enter-submit-code",
        globalUrl: "/panel/signIn/enter-submit-code",
        name: "کد تایید",
        icon: '',
        accessRole: []
    },
    SignUp: {
        url: "panel/signUp",
        globalUrl: "/panel/signUp",
        name: "ثبت نام",
        icon: '',
        accessRole: []
    },
    SignUpIntro: {
        url: "/intro",
        globalUrl: "/panel/signUp/intro",
        name: "معرفی",
        icon: '',
        accessRole: []
    },
    SignUpSellerType: {
        url: "/seller-type",
        globalUrl: "/panel/signUp/seller-type",
        name: "نوع فروشنده",
        icon: '',
        accessRole: []
    },
    LegalPerson: {
        url: "/legal-person",
        globalUrl: "/panel/signUp/legal-person",
        name: "فروشنده حقوقی",
        icon: '',
        accessRole: []
    },
    SignInEnterPhoneNumber: {
        url: "enter-phone-number",
        globalUrl: "/panel/signIn/enter-phone-number",
        name: "ورود | ثبت نام",
        icon: '',
        accessRole: []
    },
    SignInRefreshPassword: {
        url: "refresh-password",
        globalUrl: "/panel/signIn/refresh-password",
        name: "فراموشی رمز عبور",
        icon: '',
        accessRole: []
    },
}

